/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ExerciseBodyPart의 카테고리 타입
 */
export type ExerciseBodyPartCategoryType = 'FullBody' | 'Trunk' | 'UpperLimb' | 'LowerLimb';

export const ExerciseBodyPartCategoryType = {
    FullBody: 'FullBody' as ExerciseBodyPartCategoryType,
    Trunk: 'Trunk' as ExerciseBodyPartCategoryType,
    UpperLimb: 'UpperLimb' as ExerciseBodyPartCategoryType,
    LowerLimb: 'LowerLimb' as ExerciseBodyPartCategoryType
};

